import React from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { AddIcon } from '../../assets/icons'

interface IProps {
  label: string
  onPress: () => void
  style?: any
  testID?: string
}

export const AddLink: React.FC<IProps> = ({
  label,
  onPress,
  style,
  testID,
}) => {
  return (
    <TouchableOpacity
      style={[styles.container, style]}
      onPress={onPress}
      testID={testID ?? 'add-link'}
    >
      <View style={styles.content}>
        <Text style={styles.text}>{label}</Text>
        <AddIcon width={24} height={24} />
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    marginTop: 8,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    color: '#00A0F3',
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 24,
    marginRight: 7,
    fontFamily: 'Inter',
  },
})
